import { render } from "./CreateChambre.vue?vue&type=template&id=7d0fd688&scoped=true"
import script from "./CreateChambre.vue?vue&type=script&lang=js"
export * from "./CreateChambre.vue?vue&type=script&lang=js"

import "./CreateChambre.vue?vue&type=style&index=0&id=7d0fd688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0fd688"]])

export default __exports__